/* Max Paularena product description organizer / V1.6.
   Progressive enhancement: original Shopify description remains in a native
   details element if JavaScript is off or a description doesn't match known headings.
   No product, cart, variant, navigation, or checkout behavior is modified. */
(() => {
  'use strict';
  const headers = /^(?:about\s+(?:the\s+)?art(?:work)?|story\s+behind\s+the\s+art(?:work)?|product\s+details|about\s+(?:the\s+)?product|size\s*(?:&|and)\s*fit|size\s+chart|sizing(?:\s+guide)?|measurements|materials\s*(?:&|and)\s*care|care\s+instructions|shipping(?:\s*(?:&|and)\s*production)?|production\s*(?:&|and)\s*shipping)$/i;
  const normalized = str => (str || '').replace(/\s+/g, ' ').trim();
  function category(str) {
    str = normalized(str).toLowerCase();
    if (/^about\s+(?:the\s+)?art(?:work)?$|^story\s+behind\s+the\s+art(?:work)?$/.test(str)) return 'art';
    if (/^(?:product\s+details|about\s+(?:the\s+)?product)$/.test(str)) return 'product';
    if (/^(?:size\s*(?:&|and)\s*fit|size\s+chart|sizing(?:\s+guide)?|measurements)$/.test(str)) return 'fit';
    if (/^(?:materials\s*(?:&|and)\s*care|care\s+instructions)$/.test(str)) return 'care';
    if (/^(?:shipping(?:\s*(?:&|and)\s*production)?|production\s*(?:&|and)\s*shipping)$/.test(str)) return 'shipping';
    return null;
  }
  const names = {art:'About the artwork', product:'Product details', fit:'Size & fit', care:'Materials & care', shipping:'Shipping & production'};
  function panel(kind, body) {
    const details=document.createElement('details');
    details.className='max-pdp-detail';
    details.dataset.maxKind=kind;
    const summary=document.createElement('summary');
    const title=document.createElement('span');
    title.textContent=names[kind] || 'Product information';
    const plus=document.createElement('span');
    plus.className='max-pdp-detail__plus';
    plus.setAttribute('aria-hidden','true');
    plus.textContent='+';
    summary.append(title,plus);
    const content=document.createElement('div');
    content.className='max-pdp-detail__content rte';
    content.append(...Array.from(body.childNodes));
    details.append(summary,content);
    return details;
  }
  function meaningful(node) {return Boolean(normalized(node.textContent) || node.querySelector?.('img,video,table,iframe'));}
  // Separate actual chart tables rather than showing a huge table inside product details.
  function separateTables(detailsBody) {
    const table=detailsBody.querySelector('table');
    if (!table) return null;
    const range=document.createRange();
    range.setStartBefore(table);
    range.setEnd(detailsBody, detailsBody.childNodes.length);
    const extracted=range.extractContents();
    if (!meaningful(extracted)) return null;
    return extracted;
  }
  function candidates(source) {
    const all=Array.from(source.querySelectorAll('h2,h3,h4,h5,h6,p'));
    return all.filter(el=>{
      // A p is only a section heading if it contains nothing except a short bold heading.
      const text=normalized(el.textContent);
      if(!headers.test(text))return false;
      if (el.tagName==='P') {
        if (el.querySelector('table,img,a')) return false;
        if (!(el.querySelector('strong,b') || el.children.length===0)) return false;
      }
      return true;
    }).filter(el=>!all.some(ancestor=>ancestor!==el && ancestor.contains(el) && headers.test(normalized(ancestor.textContent))));
  }
  function transform(root) {
    const fallback=root.querySelector('[data-max-description-fallback]');
    const source=root.querySelector('[data-max-description-source]');
    if(!fallback||!source)return;
    const headersFound=candidates(source);
    const existing=new Set(Array.from(root.querySelectorAll('[data-max-kind]')).map(el=>el.dataset.maxKind));
    existing.delete('fallback');
    const groups=[];
    if(headersFound.length){
      const start=document.createRange();
      start.selectNodeContents(source);
      start.setEndBefore(headersFound[0]);
      const intro=start.cloneContents();
      if(meaningful(intro)) groups.push({kind:'product',body:intro});
      for(let i=0;i<headersFound.length;i++){
        const kind=category(headersFound[i].textContent);
        if(!kind)continue;
        const r=document.createRange();
        r.setStartAfter(headersFound[i]);
        if(headersFound[i+1])r.setEndBefore(headersFound[i+1]);
        else r.setEnd(source,source.childNodes.length);
        const body=r.cloneContents();
        if(meaningful(body)) groups.push({kind,body});
      }
    } else {
      const body=source.cloneNode(true);
      groups.push({kind:'product',body});
    }
    const output=[];
    for (const group of groups){
      if(group.kind==='product' && !existing.has('fit')){
        const sizeTables=separateTables(group.body);
        if(meaningful(group.body) && !existing.has('product')) output.push(panel('product',group.body));
        if(sizeTables && meaningful(sizeTables)) output.push(panel('fit',sizeTables));
      }else if(!existing.has(group.kind) && meaningful(group.body)){
        output.push(panel(group.kind,group.body));
      }
    }
    if(!output.length)return; // never discard the merchant's original description
    // Add only new panels; don't duplicate metafield-supplied sections.
    fallback.replaceWith(...output);
  }
  function init(){document.querySelectorAll('[data-max-product-details]').forEach(root=>{
    try{if(root.dataset.maxEnhanced==='true')return;transform(root);root.dataset.maxEnhanced='true';}catch(err){console.warn('Product details preserved in original layout:',err);}
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
